/* eslint-disable max-len */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-case-declarations */
import { CONVERSATION_ACTIVE_CONVERSATION } from '../conversationActive/types';

import * as ACTION_TYPES from './types';

const initData = {
  consultId: -1,
};
const initialState = {
  type: [],
  isShow: false,
  data: {},
  consult: {},
  bubbleMenuContext: {},
  activeContextGroup: null,
  isEligibleIssueMC: true,
  status: {
    isEligibleIssueMC: -1,
  },
  error: {
    isEligibleIssueMC: null,
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.CONTEXT_MENU_CHANGE_TYPE:
      return {
        ...state,
        type: payload.pushHistory ? [...state.type, payload.type] : [payload.type],
        data: payload.data ? payload.data : initData,
        isShow: true,
      };
    case ACTION_TYPES.CONTEXT_MENU_HIDE: {
      const { isClose } = payload;
      const newType = state.type?.slice(0, -1);
      return {
        ...state,
        type: newType,
        isShow: isClose ? false : newType.length > 0,
      };
    }
    case ACTION_TYPES.CONSULT_RETRIEVE_SUCCEED:
      return {
        ...state,
        isShow: false,
      };
    case CONVERSATION_ACTIVE_CONVERSATION:
      return initialState;

    case ACTION_TYPES.CONTEXT_BUBBLE_MENU_CHANGE_TYPE:
      const { groupId, data, conversationActive } = payload;
      const contextBBMenu = {
        ...data,
        type:
          data.pushHistory && state.bubbleMenuContext?.hasOwnProperty(groupId)
            ? [...state.bubbleMenuContext[groupId].type, data.type]
            : [data.type],
      };
      return {
        ...state,
        activeContextGroup: conversationActive,
        bubbleMenuContext: {
          [groupId]: {
            ...contextBBMenu,
          },
        },
      };
    case ACTION_TYPES.CONTEXT_BUBBLE_MENU_HIDE:
      const { id } = payload;
      const newType = state.bubbleMenuContext[id].type?.slice(0, -1);
      const contextMenu = {
        ...state.bubbleMenuContext[id],
        type: newType,
        isShow: newType.length > 0,
      };
      return {
        ...state,
        bubbleMenuContext: {
          [id]: {
            ...contextMenu,
          },
        },
      };
    case ACTION_TYPES.CLOSE_ALL_BUBBLE_MENU:
      const newObj = Object.entries(state.bubbleMenuContext).forEach(([key]) => ({
        ...state.bubbleMenuContext[key],
        isShow: false,
      }));
      return {
        ...state,
        bubbleMenuContext: newObj,
      };

    case ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_REQUEST:
      return {
        ...state,
        status: {
          isEligibleIssueMC: 0,
        },
      };
    case ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_SUCCEED:
      return {
        ...state,
        isEligibleIssueMC: true,
        status: {
          isEligibleIssueMC: 1,
        },
      };
    case ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_FAILED:
      return {
        ...state,
        isEligibleIssueMC: false,
        status: {
          isEligibleIssueMC: 2,
        },
        error: {
          ...state.error,
          isEligibleIssueMC: error,
        },
      };
    default:
      return state;
  }
}
